/**
 * Adds a cache-busting timestamp parameter to a URL.
 * This forces browsers to fetch the latest version instead of using cached content.
 *
 * @param {string} url - The URL to add cache-busting parameter to
 * @returns {string} - URL with timestamp parameter appended
 */
export const addCacheBuster = (url) => {
  if (!url) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}t=${Date.now()}`;
};
